import { render, staticRenderFns } from "./pickup-list-item.vue?vue&type=template&id=87627e3c&"
import script from "./pickup-list-item.vue?vue&type=script&lang=js&"
export * from "./pickup-list-item.vue?vue&type=script&lang=js&"
import style0 from "./pickup-list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87627e3c')) {
      api.createRecord('87627e3c', component.options)
    } else {
      api.reload('87627e3c', component.options)
    }
    module.hot.accept("./pickup-list-item.vue?vue&type=template&id=87627e3c&", function () {
      api.rerender('87627e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/pickup-list-item.vue"
export default component.exports